<template>
  <b-form-row>
    <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="title">
      <CidadeList :estado="estado" :prefix="updatedPrefix" @onDblClickCidade="cidadeSelect" />
    </b-modal>

    <lg-form-input-finder :value="computedValue" @input="updateValue" fieldDescription="municipio" label="Cidade:*"
      invalidFeedback="Cidade deve ser informada!" description="" :disabled="disabled" @handleClean="handleClean">
      <template #prepend>
        <b-button @click="show" class="btn-input-finder" pressed :disabled="disabled">
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import CidadeList from "@/modules/cadastros/cidade/CidadeList.vue";

export default {
  components: { LgFormInputFinder, CidadeList },
  props: {
    id: String,
    prefix: Array,
    codEmpresa: Number,
    value: Object,
    disabled: Boolean,
    estado: Number
  },
  computed: {
    computedValue() {
      return this.value || {};
    },
    updatedPrefix() {
      return [...this.prefix, "Cidade"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    show() {
      this.$bvModal.show(this.id);
    },
    updateValue(newValue) {
      this.computedValue = newValue;
      this.$emit('input', newValue);
    },
    handleClean() {
      this.computedValue = {};
      this.$emit('input', {});
    },
    cidadeSelect(item) {
      this.computedValue = item;
      this.$emit('input', item);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
